import React from "react";
import ModalImage from "react-modal-image";
import Page from "../../components/layouts/page";
import CompanyWebsite1 from "../../images/company-website.png";
import CompanyWebsite2 from "../../images/company-website-1.png";
import CompanyWebsite3 from "../../images/company-website-2.png";

export default function CompanyWebsite() {
    return (
        <Page>
            <section className="section bg-white">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6"
                            data-sal="fade"
                            data-sal-delay="200"
                            data-sal-duration="700"
                            data-sal-easing="ease">
                            <div className="skills-img me-0 me-lg-5">
                                <ModalImage small={CompanyWebsite1} large={CompanyWebsite1} alt="Company Website" className="img-fluid rounded shadow-sm"/>
                                <div className="mt-3 clearfix">
                                    <div className="w-50 float-start pe-2">
                                        <ModalImage small={CompanyWebsite2} large={CompanyWebsite2} alt="Company Website" className="img-fluid rounded shadow-sm" />
                                    </div>
                                    <div className="w-50 float-end ps-2">
                                        <ModalImage small={CompanyWebsite3} large={CompanyWebsite3} alt="Company Website" className="img-fluid rounded shadow-sm" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="section-head mt-5 mt-lg-0"
                                data-sal="slide-up"
                                data-sal-delay="200"
                                data-sal-duration="600"
                                data-sal-easing="ease">
                                <span className="pre-title small position-relative fw-bold text-dark text-uppercase">Website</span>
                                <h2 className="section-title text-dark mt-3">Company Website</h2>
                                <p className="section-subtitle mt-3">Develop, deploy and maintain company website.</p>
                                <ul className="check-list list-unstyled mb-0">
                                    <li>Create website pages.</li>
                                    <li>Add plugins.</li>
                                    <li>Maintain and upgrade to new technologies.</li>
                                </ul>
                            </div>
                            <div className="skills-content mt-2 me-0 me-md-5">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="mt-4"
                                            data-sal="slide-left"
                                            data-sal-delay="200"
                                            data-sal-duration="600"
                                            data-sal-easing="ease">
                                            <div className="clearfix">
                                                <span className="d-block w-50 float-start fw-bold small">Wordpress</span>
                                                <span className="d-block w-50 float-end fw-bold small text-end">100%</span>
                                            </div>
                                            <div className="progress mt-2">
                                                <div className="progress-bar bg-warning text-dark" role="progressbar" style={{ width: '100%' }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" aria-label="Progress Bar"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Page>
    );
}
